module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-light-gray@3x-c72d1b788dc582c6ed1a5709f3e2d45f.png";